import { render, staticRenderFns } from "./FusionBrowse.vue?vue&type=template&id=78c67d4e&scoped=true"
import script from "./FusionBrowse.vue?vue&type=script&lang=js"
export * from "./FusionBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c67d4e",
  null
  
)

export default component.exports